/**
 * Case studies: Splide carousel at 768px and below; destroyed from 769px up (grid layout).
 */
(function () {
  function initCaseStudies(root) {
    const ctx = root && root.querySelectorAll ? root : document;

    if (typeof Splide === "undefined") {
      setTimeout(function () {
        initCaseStudies(root);
      }, 100);
      return;
    }

    ctx.querySelectorAll("[data-case-studies-slider]").forEach(function (section) {
      const el = section.querySelector(".case-studies__splide");
      if (!el) {
        return;
      }

      if (el.__splideInstance) {
        try {
          el.__splideInstance.destroy(true);
        } catch (e) {
          /* ignore */
        }
        el.__splideInstance = null;
      }

      try {
        const splide = new Splide(el, {
          type: "slide",
          rewind: true,
          perPage: 1,
          gap: "20px",
          arrows: false,
          pagination: false,
          mediaQuery: "min",
          breakpoints: {
            769: {
              destroy: true,
            },
          },
        });

        splide.mount();
        el.__splideInstance = splide;

        if (!section.__caseStudiesArrowDelegation) {
          section.__caseStudiesArrowDelegation = true;
          section.addEventListener("click", function (ev) {
            const splideEl = section.querySelector(".case-studies__splide");
            const inst = splideEl && splideEl.__splideInstance;
            if (!inst) {
              return;
            }
            if (ev.target.closest(".case-studies__arrow--prev")) {
              inst.go("<");
            }
            if (ev.target.closest(".case-studies__arrow--next")) {
              inst.go(">");
            }
          });
        }

        splide.on("destroy", function () {
          el.__splideInstance = null;
        });
      } catch (err) {
        /* silent */
      }
    });
  }

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      initCaseStudies(document);
    });
  } else if (typeof jQuery !== "undefined") {
    jQuery(function () {
      initCaseStudies(document);
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initCaseStudies(document);
    });
  }

  if (typeof acf !== "undefined" && typeof acf.addAction === "function") {
    acf.addAction("render_block_preview/type=case-studies", function ($block) {
      const el = $block && $block[0] ? $block[0] : null;
      initCaseStudies(el || document);
    });
  }
})();
